import { render, staticRenderFns } from "./Partner.vue?vue&type=template&id=16c208e8&scoped=true"
import script from "./Partner.vue?vue&type=script&setup=true&lang=js"
export * from "./Partner.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Partner.vue?vue&type=style&index=0&id=16c208e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c208e8",
  null
  
)

export default component.exports